import React from 'react';

export const RECIPIENT = {
    MULTIPLE_CLASSES: {name: 'Multiple classes', display: 'Classes', val: 'MULTIPLE_CLASSES', inputLabel: 'Classes', multipleDropDown: true},
    SINGLE_CLASS: {name: 'Single class', display: 'Students in Class', val: 'SINGLE_CLASS', inputLabel: 'Class', multipleDropDown: false}
};

export const RECIPIENT_ARR = [RECIPIENT.MULTIPLE_CLASSES, RECIPIENT.SINGLE_CLASS];

export const EDIT_ASSIGN_OBJECT = {
    TEST_TYPE: {
        ASSESSMENT: {name: 'Assessment', diagnosticName: 'One sitting', val: 'ASSESSMENT', extraTxt: "To be completed in one sitting, with answers provided on assessment expiry."},
        REVISION: {name: 'Revision', diagnosticName: 'Multiple sittings', val: 'REVISION', extraTxt: "Can be completed over a number of sittings, with answers provided immediately on submission."},
        PATHWAY: {name: 'Directed Task', val: 'PATHWAY'},
        QUICK: {name: 'Quick Test', val: 'QUICK'}
    },
    TEST_TYPE_TOOLTIP: <div><p>Assessment format: To be completed in one sitting, with answers provided on assessment expiry.</p>
        <p>Revision format: Can be completed over a number of sittings, with answers provided immediately on submission.</p></div>,
    START_END_DATE_TOOLTIP_ASSESSMENT: <div>
        <p>Students can begin the test after the start time.</p>
        <p>Students need to complete and submit the test by the expiry time.</p>
    </div>,
    START_END_DATE_TOOLTIP_REVISION: <div>
        <p>Students can begin revision after the start time.</p>
        <p>Students need to complete and submit the revision by the expiry time.</p>
    </div>,
    START_END_DATE_TOOLTIP: <div className={'tooltip-wrapper'}>
        <p>Students can begin the test after the start time.</p>
        <p>Students need to complete and submit the test by the expiry time.</p>
    </div>,
    SHOW_RESULTS_ON_EXPIRY_TOOLTIP: <div className={'tooltip-wrapper'}>
        <p>One sitting assignments: Results can be viewed upon test expiry.</p>
        <p>Multiple sitting assignments: Results can be viewed immediately on submission</p>
    </div>,
    START_DATE_TOOLTIP: "Students can begin the test after the start time.",
    END_DATE_TOOLTIP: "Students need to submit the test by the expiry time.",
    SHOW_RESULTS_ONE_SITTING_TOOLTIP: "Students can view results upon test expiry.",
    SHOW_RESULTS_MULTIPLE_SITTING_TOOLTIP: "Students can view results upon submission."
}